import { GridApi, GridOptions, createGrid } from 'ag-grid-community';
import { Role } from '../RolePanelTypes';
export class RolesGrid {
    public api: GridApi<Role>;
    private readonly containerEl: HTMLElement;

    constructor(containerEl: HTMLElement) {
        this.containerEl = containerEl;
    }

    public async init(): Promise<void> {
        const response = await fetch('/rolePanel/roles');
        const data: Role[] = await response.json();

        const gridOptions: GridOptions = {
            rowData: data,
            columnDefs: [{ field: 'Name', headerName: 'Roles', flex: 1, resizable: false }],
            rowSelection: 'single',
            suppressCellFocus: true,
            onFirstDataRendered: (params) => params.api.getDisplayedRowAtIndex(0).setSelected(true),
        };
        this.api = createGrid(this.containerEl, gridOptions);

        const firstDataRender = new Promise<void>((resolve) => {
            this.api.addEventListener('firstDataRendered', () => {
                resolve();
            });
        });
        await firstDataRender;
    }
}
